import { render } from "./CustomerBlog.vue?vue&type=template&id=1a0215bd"
import script from "./CustomerBlog.vue?vue&type=script&lang=js"
export * from "./CustomerBlog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__